exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-whatsapp .my-img[data-v-49fcbfe0]{object-fit:cover}.container-whatsapp .container-buttons[data-v-49fcbfe0]{text-align:right}.my-iframe[data-v-49fcbfe0]{height:280px!important}.my-iframe-2[data-v-49fcbfe0]{height:780px!important}.my-iframe-audio[data-v-49fcbfe0]{height:200px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49fcbfe0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/Mensajes/MensajesUnificado/WhatsAppMessage/WhatsAppMessage.scss
// module id = 1036
// module chunks = 0